import React, { useState } from "react";

import SourcedInfo from "./SourcedInfo";
import { AiModal } from "../Quote/Leads";
import { isMobile } from "react-device-detect";
import LeadsAdditionalRecordItem from "./LeadsAdditionalRecordItem";

const SourcedItemView = ({
  item,
  newPriority,
  isFromUsersPage,
  isLeadsPage = false,
  type = null,
  selected = false,
  onOpen,
}) => {
  const [shouldHide, setShouldHide] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  if (shouldHide) {
    return null;
  }

  // The row is now ONE line in a directory: no card wrapper, no inline quotes panel and no action
  // column. Quotes and commands moved to the page's right-hand panel (OrderQuotesDrawer), so a row
  // can never grow and the list stays scannable however many quotes an order carries.
  return (
    <>
      {isLeadsPage && item.additional_records?.length > 0 ? (
        <LeadsAdditionalRecordItem item={item}>
          <div className="col action-button-width">
            <div
              className={`item-col`}
              style={{ textAlign: isMobile ? "left" : "right" }}
            >
              <button onClick={() => setIsOpen(true)}>View</button>
            </div>
          </div>
        </LeadsAdditionalRecordItem>
      ) : (
        <SourcedInfo
          {...{
            item,
            newPriority,
            shouldHide,
            isFromUsersPage,
            isLeadsPage,
            selected,
            onOpen: isLeadsPage ? () => setIsOpen(true) : onOpen,
          }}
        />
      )}

      <AiModal
        isOpen={isOpen}
        item={item}
        hide={() => setIsOpen(false)}
        isOpportunityModal={type === "opportunities" || type === "in-stock" || type === "in-consignment"}
        approveBlack
      />
    </>
  );
};

export default SourcedItemView;
